import axios from 'axios';
import { Auth0Wrapper } from '../../services/auth0/Auth0Wrapper';
import * as Cookies from '../../constants/cookies';
import { CookieService } from '../../services/cookie-service';
import { AuthenticationService } from '../../services/authentication-service';
import { LocalStorageService } from '../../services/local-storage-service';
import { LogService } from '../../services/log-service';
import * as AuthConstants from '../constants';
import { LoginService } from '../login/login-service';
import { Yofi } from '../../services/analytics-services/yofi';
import { Segment } from '../../services/analytics-services/segment';
import { USER_SESSION_END } from '../../constants/analytics-events';

class LogoutServiceClass {
  constructor() {
    this.logout = this.logout.bind(this);
    this.isLoggedOut = false;
  }

  logoutActions(redirectTo, logoutType, authority) {
    if (authority === AuthConstants.IssuingAuthorityAuth0) {
      return Auth0Wrapper.logout(redirectTo, logoutType);
    }
    if (authority === AuthConstants.IssuingAuthorityNative) {
      if (logoutType === AuthConstants.LogoutTypeMaintenance) {
        CookieService.setCookieValueWithExpirationInMinutes(Cookies.NeedsLoggedOutForMaintMsg, logoutType, 15);
      }
      window.location.href = redirectTo;
      return Promise.resolve(true);
    }
    // this is the case if there is no issuing authority i.e. we're already logged out.
    window.location.href = redirectTo;
    return Promise.resolve(false);
  }

  logout(redirectTo, logoutType) {
    if (this.isLoggedOut) {
      return;
    }
    this.isLoggedOut = true;
    const authority = AuthenticationService.getAuthority();
    try {
      const userInfo = LoginService.getCurrentUserInfo();
      Segment.trackEvent(USER_SESSION_END, {
        type: USER_SESSION_END,
        ...userInfo,
        logoutType,
        authority,
      });
      Yofi.handleLogout();
    } catch (e) {
      LogService.logError(e);
    }

    const redirectToWithFallback = redirectTo || `${window.location.origin}/logout`;

    return axios
      .post('Auth/LogOut', {})
      .catch((e) => {
        LogService.logError(e);
      })
      .finally(() => {
        this.clearCookiesAndStorage();
        return this.logoutActions(redirectToWithFallback, logoutType, authority);
      });
  }

  clearCookiesAndStorage() {
    try {
      CookieService.removeAuthentication();
      CookieService.removeV3Config();
      LocalStorageService.clear();
    } catch (e) {
      LogService.logError(e);
    }
  }
}

export const LogoutService = new LogoutServiceClass();
